/**
 * Build the conditional `manuals` fragment of the price-endpoint payload from
 * the selected service objects (Order Flow V2 — EXE-234/EXE-235).
 *
 * The backend wants the selected services sent the same way `deliveryFormats`
 * are sent — `manuals: [{ id }]` — and, like `deliveryFormats`, the key is
 * omitted entirely when nothing is selected (so it never widens the payload of
 * the create-order or edit flows that have no services). Spread the result into
 * the price `data` object:
 *
 *   data: { buildings, exports, ...buildManualsPricePayload(services) }
 *
 * @param {Array<{id: number}>} [services] selected service objects (plain JS,
 *   from `projectTemp.services`)
 * @returns {{manuals: Array<{id: number}>}|{}} the fragment, or `{}` when empty
 */
export const buildManualsPricePayload = (services) =>
	services && services.length > 0
		? { manuals: services.map((service) => ({ id: service.id })) }
		: {};
